export default __webpack_public_path__ + "static/media/cartoon-project.b7e7bffe.jpg";